import { Controller } from "stimulus";

class AmountController extends Controller {
    static targets = ["optionButton", "otherOptionButton", "otherSection", "otherInput", "otherSectionError", "otherDiscountInfo"];

    get paymentAmount() {
        return parseFloat(this.data.get("payment-amount"));
    }

    set paymentAmount(value) {
        this.data.set("payment-amount", value.toString());
        this.publishPaymentAmountUpdatedEvent(value);
    }

    get voucherValue() {
        return parseFloat(this.data.get("voucher-value"));
    }

    set voucherValue(value) {
        this.data.set("voucher-amount", value.toString());
        this.publishVoucherValueUpdatedEvent(value);
    }

    get discountType() {
      return this.data.get("discount-type");
    }


    get discountEnabled() {
        return this.data.get("discount-enabled") === 'true';
    }

    get discount() {
        return parseInt(this.data.get("discount"));
    }

    get otherSectionVisible() {
        return !this.otherSectionTarget.classList.contains("hidden");
    }

    set otherSectionVisible(visible) {
        this.otherSectionTarget.classList.toggle("hidden", !visible);
        this.otherSectionErrorTarget.classList.toggle("hidden", !visible);
    }

    get otherInputValue() {
        return this.otherInputTarget.value;
    }

    set otherInputValue(value) {
        this.otherInputTarget.value = value;
    }

    get discountSpanTemplate() {
        return this.data.get("discount-span-template");
    }

    optionSelected(event) {
        this.otherSectionVisible = false;
        this.paymentAmount = parseFloat(event.target.getAttribute("data-payment-amount"));
        this.voucherValue = parseFloat(event.target.getAttribute("data-voucher-value"));
        let displayValue = parseInt(event.target.getAttribute("data-display-amount"));
        this.updateFixedOptionSelection(displayValue);
    }

    otherOptionSelected() {
        this.otherSectionVisible = true;
        this.value = 0;
        this.otherInputValue = "";
        this.validateOtherFieldAmount();
        this.otherInputTarget.focus();
        this.updateFixedOptionSelection(0);
        this.toggleOptionSelection(this.otherOptionButtonTarget, true);
    }

    otherInputUpdated() {
        if (this.validateOtherFieldAmount()) {
            const selectedAmount = parseInt(this.otherInputValue);
            this.paymentAmount = this.calculatePaymentAmount(selectedAmount);
            this.voucherValue = this.calculateVoucherAmount(selectedAmount);
            this.otherDiscountInfoTarget.innerHTML = this.discountSpanTemplate.replace('AMOUNT', this.discountAmountInfo(selectedAmount));
            this.otherDiscountInfoTarget.classList.toggle('hidden', !this.discountEnabled);
        } 
    }

    preventInvalidCharacters(event) {
        let maxLengthExceeded = this.value.toString().length >= 16;
        let correctKey = event.metaKey || event.which <= 0 || event.which == 8 || /[0-9]/.test(String.fromCharCode(event.which)); // numbers
        if (!correctKey || maxLengthExceeded) {
            event.preventDefault();
        }
    }

    publishPaymentAmountUpdatedEvent(value) {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent("payment-amount-updated", true, true, null);
        event.paymentAmount = value;
        this.element.dispatchEvent(event);
    }

    publishVoucherValueUpdatedEvent(value) {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent("voucher-value-updated", true, true, null);
        event.voucherValue = value;
        this.element.dispatchEvent(event);
    }

    validateOtherFieldAmount() {
        if (this.otherInputValue === "") {
            this.otherSectionErrorTarget.innerHTML = this.data.get('required-error');
            this.otherSectionErrorTarget.classList.remove('hidden');
            return false;
        } else if (this.invalidOtherAmountValue()) {
            this.otherSectionErrorTarget.innerHTML = this.data.get('spend-error')
            this.otherSectionErrorTarget.classList.remove('hidden');
            return true;
        } else {
            this.otherSectionErrorTarget.classList.add('hidden');
            return true;
        }
    }

    invalidOtherAmountValue() {
        let value = parseInt(this.otherInputValue);
        let paymentAmount = this.calculatePaymentAmount(value);
        return paymentAmount < this.data.get('min-spend-amount') || paymentAmount > this.data.get('max-spend-amount');
    }


    updateFixedOptionSelection(displayValue) {
        this.optionButtonTargets.forEach((optionButton) => {
            let optionValue = optionButton.getAttribute("data-display-amount");
            let selected = parseInt(optionValue) === displayValue;
            this.toggleOptionSelection(optionButton, selected);
        });
        this.toggleOptionSelection(this.otherOptionButtonTarget, false);
    }


    updateOtherOptionForInitialState() {
        let otherOptionButton = this.otherOptionButtonTarget;
        if (this.value === 0) { // no option nor value is set yet
            this.toggleOptionSelection(otherOptionButton, false);
        } else { // connecting with a other value set
            this.otherSectionVisible = true;
            this.otherInputValue = this.paymentAmount;
            this.toggleOptionSelection(otherOptionButton, true);
        }
    }

    toggleOptionSelection(optionButton, selected) {
        optionButton.checked = selected;
    }

    calculateVoucherAmount(value) {
        if (this.discountType === "value_add") {
            return value + this.discountAmount(value);

        } else {
            return value;
        }
    }

    calculatePaymentAmount(value) {
        if (this.discountType === 'price_reduction') {
            return value - this.discountAmount(value);
        } else {
            return value;
        }
    }

    discountAmount(value) {
        if (!this.discountEnabled)
            return 0;
        return value * (this.discount/100.0);
    }

    discountAmountInfo(value) {
        if (this.discountType === 'price_reduction') {
            return (value - this.discountAmount(value)).toFixed(2);
        } else {
            return this.discountAmount(value).toFixed(2);
        }
    }
}

export default AmountController;
